// extracted by mini-css-extract-plugin
export default {"mainSection":"VerificationFailedPage_mainSection__bMBee"};